(function(){
  document.querySelectorAll('[id^="ddi-sp-"]').forEach(function(root){
  var isDesktop = window.matchMedia('(min-width: 750px) and (hover: hover)').matches;
  var reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var data = {__map:{}, __videos_by_handle:{}, __seed:[]};
  try {
    data = JSON.parse(root.querySelector('.ddi-sp__catalog').textContent) || data;
  } catch(e){}
  var catalog = data.__map || {};
  var vidsBy  = data.__videos_by_handle || {};
  var seed    = data.__seed || [];
  var pool    = data.__pool_handles || [];

  /* F-20260904-32: poster-first strip, gated twice, with a hard cap on live clips.
     Before this, every tile shipped a real <video preload="metadata"> and the strip observer
     autoplayed whatever was horizontally in view - while the section was still far below the
     fold. Measured on the live PDP: 52.2 MB of clip data pulled within 5 s of landing, on a
     section nobody had scrolled to. Muted+playsinline+loop remains mobile-autoplay-safe. Opt
     out on reduce-motion and save-data. This block fires no tracking of any kind. */
  (function(){
    var canPreview = !reduced;
    try{
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if(conn && conn.saveData) canPreview = false;
      if(conn && (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) canPreview = false;
    }catch(e){}
    var scroller = root.querySelector('.ddi-sp__scroller');
    var tiles = root.querySelectorAll('.ddi-sp__tile[data-kind="video"]');
    if(!tiles.length || !scroller) return;
    if(!canPreview || !('IntersectionObserver' in window)){
      /* No preview: still reveal the deferred cards so the strip is browsable. */
      root.classList.add('ddi-sp--revealed');
      return;
    }

    /* At most MAX_LIVE clips may exist at once. Creating a <video> per tile and never
       destroying one is what locked the homepage up - elements pile up holding a src and all
       keep buffering. Disposal pauses, drops the src and calls load() to cancel the fetch. */
    var MAX_LIVE = 3, SETTLE_MS = 250, liveTiles = [], disposeTimers = new WeakMap(), hydrateTimers = new WeakMap();

    function dispose(tile){
      var v = tile.querySelector('video');
      if(!v) return;
      try{ v.pause(); v.removeAttribute('src'); v.load(); }catch(e){}   /* load() cancels the fetch */
      if(v.parentNode) v.parentNode.removeChild(v);                     /* poster shows again */
      var i = liveTiles.indexOf(tile);
      if(i > -1) liveTiles.splice(i,1);
    }
    function cancelDispose(tile){
      var t = disposeTimers.get(tile);
      if(t){ clearTimeout(t); disposeTimers.delete(tile); }
    }
    /* A tile must stay in view for SETTLE_MS before anything is fetched, so scrubbing past a
       card never starts a download. */
    function cancelHydrate(tile){
      var t = hydrateTimers.get(tile);
      if(t){ clearTimeout(t); hydrateTimers.delete(tile); }
    }
    function hydrateSettled(tile){
      if(hydrateTimers.get(tile) || tile.querySelector('video')) return;
      hydrateTimers.set(tile, setTimeout(function(){
        hydrateTimers.delete(tile);
        var v = hydrate(tile);
        if(v){ try{ v.muted = true; v.play().catch(function(){}); }catch(e){} }
      }, SETTLE_MS));
    }
    function scheduleDispose(tile){
      cancelDispose(tile);
      disposeTimers.set(tile, setTimeout(function(){ disposeTimers.delete(tile); dispose(tile); }, 1200));
    }

    /* Build (once) the <video> for a tile and fade it in over the poster. */
    function hydrate(tile){
      cancelDispose(tile);
      var v = tile.querySelector('video');
      if(v) return v;
      while(liveTiles.length >= MAX_LIVE){ dispose(liveTiles[0]); }
      var src = tile.getAttribute('data-src');
      if(!src) return null;
      v = document.createElement('video');
      v.className = 'ddi-sp__media';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('loop','');
      v.setAttribute('preload','auto');
      v.setAttribute('width','600'); v.setAttribute('height','800');
      v.setAttribute('aria-hidden','true');
      var poster = tile.getAttribute('data-poster');
      if(poster) v.setAttribute('poster', poster);
      v.addEventListener('canplay', function(){ v.classList.add('is-ready'); }, {once:true});
      v.src = src;
      tile.appendChild(v);
      liveTiles.push(tile);
      return v;
    }

    /* Horizontal gate - only runs once the section gate below has armed it. */
    var stripIO = null;
    function armStrip(){
      if(stripIO) return;
      stripIO = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting && en.intersectionRatio > 0.35){
            cancelDispose(en.target);
            var ex = en.target.querySelector('video');
            if(ex){ try{ ex.muted = true; ex.play().catch(function(){}); }catch(e){} }
            else { hydrateSettled(en.target); }
          } else {
            cancelHydrate(en.target);     /* scrubbed past - never start the fetch */
            var ev = en.target.querySelector('video');
            if(ev){ try{ ev.pause(); }catch(e){} }
            scheduleDispose(en.target);   /* free it if the user has moved on */
          }
        });
      }, { root: scroller, threshold: [0, 0.35, 0.75], rootMargin: '0px 40px' });
      root.querySelectorAll('.ddi-sp__tile[data-kind="video"]').forEach(function(t){ stripIO.observe(t); });
    }

    /* Vertical gate - nothing above happens until the section approaches the viewport. */
    var sectionIO = new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        if(entries[i].isIntersecting){
          root.classList.add('ddi-sp--revealed');   /* reveal cards beyond the initial batch */
          armStrip();
          sectionIO.disconnect();
          break;
        }
      }
    }, { root: null, rootMargin: '300px 0px', threshold: 0 });
    sectionIO.observe(root);

    /* desktop hover: hydrate immediately and restart for an instant motion cue */
    if(isDesktop && !reduced){
      tiles.forEach(function(tile){
        tile.addEventListener('mouseenter', function(){
          var v = hydrate(tile);
          if(v){ try{ v.currentTime=0; v.play().catch(function(){}); }catch(e){} }
        });
      });
    }
  })();

  var feed     = root.querySelector('.ddi-feed');
  var feedScr  = root.querySelector('.ddi-feed__scroll');

  var STATE = {
    queue: [],           // ordered list of feed records
    urlSet: {},          // for dedupe
    curIdx: 0,
    muted: true,
    historyPushed: false // true while a history entry is in place for the modal
  };

  function slugHash(u){ return u.replace(/[^\w]/g,'').slice(-40); }

  /* Build initial queue: tapped-first, then remaining seed, then discovery hop */
  function buildQueue(tappedUrl){
    STATE.queue = [];
    STATE.urlSet = {};

    function push(r){
      if(!r || !r.url) return;
      if(STATE.urlSet[r.url]) return;
      STATE.urlSet[r.url] = true;
      STATE.queue.push(r);
    }

    // 1) tapped first
    var tapped = null;
    for(var i=0;i<seed.length;i++){ if(seed[i].url === tappedUrl){ tapped = seed[i]; break; } }
    if(tapped) push(tapped);

    // 2) remaining seed (in order)
    seed.forEach(push);

    // 3) discovery hop: for each queue item's handles, add their videos
    var initialLen = STATE.queue.length;
    for(var j=0;j<initialLen;j++){
      var handles = STATE.queue[j].product_handles || [];
      handles.forEach(function(h){
        var vids = vidsBy[h] || [];
        vids.forEach(push);
      });
    }

    // 4) another hop for breadth
    var expLen = STATE.queue.length;
    for(var k=initialLen;k<expLen;k++){
      var hs = STATE.queue[k].product_handles || [];
      hs.forEach(function(h){
        var vids = vidsBy[h] || [];
        vids.forEach(push);
      });
    }

    // 5) discovery pool: dump every pool product's videos into the queue.
    // This is what gives the "endless TikTok scroll" beyond current product.
    // Shuffle so the pool feels fresh each open.
    var poolShuffled = pool.slice(0).sort(function(){ return Math.random() - 0.5; });
    poolShuffled.forEach(function(h){
      var vids = vidsBy[h] || [];
      vids.forEach(push);
    });

    // 6) implicit fallback pool: if the explicit collection isn't wired yet, we
    // still want the feed to feel endless. Dump every video in the catalog
    // (transitive closure of everything the current PDP knows about), shuffled.
    var allKeys = Object.keys(vidsBy).sort(function(){ return Math.random() - 0.5; });
    allKeys.forEach(function(h){
      var vids = vidsBy[h] || [];
      vids.forEach(push);
    });
  }

  function svg(id){
    var s = {
      close: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
      soundOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>',
      soundOn:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/><path d="M15.5 8.5a5 5 0 010 7"/><path d="M19 5a10 10 0 010 14"/></svg>',
      plus:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
      heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>',
      heartSolid: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
      share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>',
      swipe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 20V6M6 12l6-6 6 6"/></svg>'
    };
    return s[id] || '';
  }

  function progressDots(n, cur){
    var out = '';
    for(var i=0;i<n;i++){
      var c = 'ddi-feed__pdot';
      if(i < cur) c += ' is-done';
      else if(i === cur) c += ' is-cur';
      out += '<span class="'+c+'"></span>';
    }
    return out;
  }

  function shopCardHtml(h){
    var p = catalog[h]; if(!p) return '';
    return ''
      + '<a class="ddi-feed__card" href="'+ (p.u||'#') +'" data-handle="'+ h +'">'
      +   '<img class="ddi-feed__card-img" src="'+ (p.i||'') +'" alt="" loading="lazy" width="50" height="50">'
      +   '<span class="ddi-feed__card-body">'
      +     '<span class="ddi-feed__card-title">'+ (p.t||'') +'</span>'
      +     '<span class="ddi-feed__card-price">'+ (p.p||'') +'</span>'
      +   '</span>'
      +   '<span class="ddi-feed__card-cta" data-add="'+ (p.v||'') +'">Add</span>'
      + '</a>';
    }

  function slideHtml(r, i, total){
    var handles = r.product_handles || [];
    var primary = handles[0] || '';
    var pInfo = catalog[primary] || null;
    var vid = pInfo ? (pInfo.v || '') : '';

    var cards = handles.map(shopCardHtml).join('');

    return ''
      + '<div class="ddi-feed__slide" data-idx="'+i+'" data-primary="'+ primary +'" data-vid="'+ vid +'">'
      +   '<video class="ddi-feed__video" src="'+ r.url +'" playsinline preload="metadata" '+(i===0?'autoplay':'')+' '+(STATE.muted?'muted':'')+' loop '+ (r.poster?('poster="'+r.poster+'"'):'') +'></video>'
      +   '<div class="ddi-feed__scrim-top"></div>'
      +   '<div class="ddi-feed__scrim"></div>'
      +   '<div class="ddi-feed__topbar">'
      +     '<button type="button" class="ddi-feed__close" aria-label="Close">'+ svg('close') +'</button>'
      +     '<div class="ddi-feed__progress" aria-hidden="true">'+ progressDots(total, i) +'</div>'
      +     '<button type="button" class="ddi-feed__mute" aria-label="Toggle sound">'+ (STATE.muted?svg('soundOff'):svg('soundOn')) +'</button>'
      +   '</div>'
      +   '<div class="ddi-feed__rail">'
      +     (vid ? '<button type="button" class="ddi-feed__act ddi-feed__act--primary" data-action="cart" data-vid="'+ vid +'" data-handle="'+ primary +'" aria-label="Add to cart">'+ svg('plus') +'</button><span class="ddi-feed__actlabel">CART</span>' : '')
      +     '<button type="button" class="ddi-feed__act" data-action="share" data-handle="'+ primary +'" aria-label="Share">'+ svg('share') +'</button><span class="ddi-feed__actlabel">SHARE</span>'
      +   '</div>'
      +   '<div class="ddi-feed__bottom">'
      +     (r.caption ? '<p class="ddi-feed__creator">'+ escapeHtml(r.caption) +'</p>' : '')
      +     (cards ? '<div class="ddi-feed__shopstrip">'+ cards +'</div>' : '')
      +   '</div>'
      +   (i===0?'<div class="ddi-feed__swipehint">'+svg('swipe')+'Swipe for more</div>':'')
      +   '<div class="ddi-feed__soundhint" data-soundhint>'+ svg('soundOn') +'Tap for sound</div>'
      +   '<div class="ddi-feed__heartburst" data-heartburst>'+ svg('heartSolid') +'</div>'
      + '</div>';
  }

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[c];}); }

  function renderFeed(){
    feedScr.innerHTML = STATE.queue.map(function(r,i){ return slideHtml(r, i, STATE.queue.length); }).join('');
    wireSlides();
  }

  var io = null;
  function wireSlides(){
    var slides = feedScr.querySelectorAll('.ddi-feed__slide');
    slides.forEach(function(slide){
      slide.querySelector('.ddi-feed__close').addEventListener('click', function(){ closeFeed(); });
      slide.querySelector('.ddi-feed__mute').addEventListener('click', function(){ toggleMute(); });

      // Right-rail actions
      slide.querySelectorAll('[data-action]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var act = btn.getAttribute('data-action');
          if(act==='cart') addToCart(btn.getAttribute('data-vid'), btn.getAttribute('data-handle'));
          else if(act==='share') shareSlide(btn.getAttribute('data-handle'));
        });
      });

      // Shop-card Add-to-Cart buttons (bottom strip)
      slide.querySelectorAll('.ddi-feed__card-cta').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var vid = btn.getAttribute('data-add');
          var handle = btn.closest('.ddi-feed__card').getAttribute('data-handle');
          if(vid) addToCart(vid, handle);
        });
      });

      // Video ended -> auto-advance to next
      var v = slide.querySelector('.ddi-feed__video');
      if(v){
        v.addEventListener('ended', function(){
          var idx = parseInt(slide.getAttribute('data-idx'),10);
          var next = feedScr.children[idx+1];
          if(next){ next.scrollIntoView({behavior:'smooth', block:'start'}); }
          else { try{ v.currentTime = 0; v.play(); }catch(e){} }
        });

        // Double-tap heart-bloom + add to cart (TikTok-style)
        var lastTap = 0;
        var singleTapTimer = null;
        v.addEventListener('click', function(e){
          var now = Date.now();
          var gap = now - lastTap;
          lastTap = now;
          if(gap < 320 && gap > 0){
            if(singleTapTimer){ clearTimeout(singleTapTimer); singleTapTimer = null; }
            // Double tap detected
            var vid = slide.getAttribute('data-vid');
            var h = slide.getAttribute('data-primary');
            var burst = slide.querySelector('[data-heartburst]');
            if(burst){
              burst.classList.remove('is-on');
              void burst.offsetWidth;
              burst.classList.add('is-on');
              setTimeout(function(){ burst.classList.remove('is-on'); }, 950);
            }
            if(vid && vid !== '0'){ addToCart(vid, h); }
          } else {
            // Single tap: toggle play/pause after a delay (in case double-tap arrives)
            singleTapTimer = setTimeout(function(){
              if(v.paused){ try{ v.play(); }catch(e){} } else { try{ v.pause(); }catch(e){} }
              singleTapTimer = null;
            }, 280);
          }
        });
      }
    });

    // IntersectionObserver: play active, pause others
    if(io) io.disconnect();
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target.querySelector('.ddi-feed__video');
        if(!v) return;
        if(en.isIntersecting && en.intersectionRatio > 0.55){
          STATE.curIdx = parseInt(en.target.getAttribute('data-idx'),10);
          try{ v.play(); }catch(e){}
          if(!STATE.muted) v.muted = false;
          // update progress dots and mute icon across all slides
          var dotStr = progressDots(STATE.queue.length, STATE.curIdx);
          feedScr.querySelectorAll('.ddi-feed__progress').forEach(function(pr){ pr.innerHTML = dotStr; });
          updateMuteIcons();
        } else {
          try{ v.pause(); }catch(e){}
        }
      });
    }, {root: feedScr, threshold: [0.55]});
    slides.forEach(function(s){ io.observe(s); });
  }

  function updateMuteIcons(){
    feedScr.querySelectorAll('.ddi-feed__mute').forEach(function(b){
      b.innerHTML = STATE.muted ? svg('soundOff') : svg('soundOn');
    });
  }

  function toggleMute(){
    STATE.muted = !STATE.muted;
    feedScr.querySelectorAll('.ddi-feed__video').forEach(function(v){ v.muted = STATE.muted; });
    updateMuteIcons();
    if(!STATE.muted){
      // Show a subtle confirmation on the active slide
      var active = feedScr.children[STATE.curIdx];
      if(active){
        var h = active.querySelector('[data-soundhint]');
        if(h){ h.classList.add('is-on'); setTimeout(function(){ h.classList.remove('is-on'); }, 1200); }
      }
    }
  }

  function openFeed(startUrl){
    buildQueue(startUrl);
    if(!STATE.queue.length) return;
    STATE.curIdx = 0;
    renderFeed();
    feed.classList.add('is-open');
    feed.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    // Push a history entry so the browser Back button (and Android system back)
    // closes the feed instead of leaving the PDP.
    try{
      history.pushState({ddiFeed:true}, '', location.href);
      STATE.historyPushed = true;
    }catch(e){}
    // ensure first slide is at top
    feedScr.scrollTop = 0;
    try{
      var v0 = feedScr.querySelector('.ddi-feed__video');
      if(v0){ v0.muted = STATE.muted; v0.play().catch(function(){}); }
    }catch(e){}
  }
  function closeFeed(fromPopstate){
    if(!feed.classList.contains('is-open')) return;
    feed.classList.remove('is-open');
    feed.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    feedScr.querySelectorAll('.ddi-feed__video').forEach(function(v){
      try{ v.pause(); v.removeAttribute('src'); v.load(); }catch(e){}
    });
    feedScr.innerHTML = '';
    if(io){ io.disconnect(); io = null; }
    // If we still own a pushed history entry and this close wasn't triggered
    // by a Back-button popstate, unwind it so the URL/history stays clean.
    if(STATE.historyPushed && !fromPopstate){
      STATE.historyPushed = false;
      try{ history.back(); }catch(e){}
    } else {
      STATE.historyPushed = false;
    }
  }

  window.addEventListener('popstate', function(){
    // Back-button (browser or Android system) while feed is open -> close only.
    if(feed.classList.contains('is-open')){
      STATE.historyPushed = false; // history entry already consumed
      closeFeed(true);
    }
  });

  /* --- Actions --- */
  function toast(msg, linkHref, linkText){
    var t = document.querySelector('.ddi-feed__toast');
    if(!t){
      t = document.createElement('div');
      t.className = 'ddi-feed__toast';
      document.body.appendChild(t);
    }
    t.innerHTML = escapeHtml(msg) + (linkHref ? ' <a href="'+linkHref+'">'+escapeHtml(linkText||'View')+'</a>' : '');
    requestAnimationFrame(function(){ t.classList.add('is-on'); });
    clearTimeout(t.__hto);
    t.__hto = setTimeout(function(){ t.classList.remove('is-on'); }, 3200);
  }

  function addToCart(variantId, handle){
    if(!variantId || variantId === '0'){ toast('This item is unavailable'); return; }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(variantId,10), quantity: 1}]})
    })
    .then(function(r){ if(!r.ok) throw r; return r.json(); })
    .then(function(){
      var p = catalog[handle];
      var name = p ? p.t : 'Item';
      toast('Added: ' + name, '/cart', 'View cart');
      // Try to nudge the theme's cart drawer if one exists
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    })
    .catch(function(){ toast('Could not add to cart'); });
  }

  function shareSlide(handle){
    var p = catalog[handle] || {};
    var url = p.u ? (location.origin + p.u) : location.href;
    var title = (p.t ? p.t + ' — ' : '') + document.title;
    if(navigator.share){
      navigator.share({title: title, url: url}).catch(function(){});
    } else if(navigator.clipboard){
      navigator.clipboard.writeText(url).then(function(){ toast('Link copied'); });
    } else {
      toast('Copy: ' + url);
    }
  }

  /* Tile click -> open feed */
  root.querySelectorAll('.ddi-sp__tile').forEach(function(tile){
    var kind = tile.getAttribute('data-kind');
    tile.setAttribute('tabindex','0');
    var open = function(){
      if(kind !== 'video'){ /* keep click a no-op for image tiles for now */ return; }
      openFeed(tile.getAttribute('data-src'));
    };
    tile.addEventListener('click', function(e){ e.preventDefault(); open(); });
    tile.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); open(); }});
  });

  /* ESC closes on desktop; Arrow keys navigate */
  document.addEventListener('keydown', function(e){
    if(!feed.classList.contains('is-open')) return;
    if(e.key === 'Escape'){ closeFeed(); return; }
    if(e.key === 'ArrowDown' || e.key === 'PageDown'){
      e.preventDefault();
      var next = feedScr.children[STATE.curIdx + 1];
      if(next) next.scrollIntoView({behavior:'smooth', block:'start'});
    }
    if(e.key === 'ArrowUp' || e.key === 'PageUp'){
      e.preventDefault();
      var prev = feedScr.children[STATE.curIdx - 1];
      if(prev) prev.scrollIntoView({behavior:'smooth', block:'start'});
    }
    if(e.key === 'm' || e.key === 'M'){ toggleMute(); }
  });
  });
})();
